/**
 * Created by Viacheslav Stepanian on 15.12.2025
 */

const SignInModel = function (options) {
    this.closed = false;

    this.restoreProgress = options.restoreProgress;

    this.onSuccess = cleverapps.once(options.onSuccess);
    this.onFailure = cleverapps.once(options.onFailure);

    this.closeWindow = function () {};
};

SignInModel.prototype.handleLoginClick = function () {
    if (this.closed) {
        return;
    }

    cleverapps.focusManager.display({
        stack: true,
        focus: "WaitSync",
        actions: [
            (f) => {
                cleverapps.loading.show();
                f();
            },

            (f) => {
                f = cleverapps.wait(2, f);
                if (connector.SYNC_STATUS.INIT === connector.synchronizer.status) {
                    connector.synchronizer.once("changeStatus", cleverapps.waitNoMore(15000, f));
                    connector.synchronizer.checkSession();
                } else {
                    f();
                }
                cleverapps.timeouts.setTimeout(f, 3000);
            },
            (f) => {
                cleverapps.loading.hide();

                f();

                if (connector.SYNC_STATUS.IDLE === connector.synchronizer.status && this.restoreProgress) {
                    cleverapps.notification.create(Messages.get("RestoreProgress.progressNotFound"));
                }

                this.closeWindow();
            }
        ]
    });
};

SignInModel.prototype.handleClose = function () {
    this.closed = true;

    if (connector.social.isLoggedIn()) {
        this.onSuccess();
    } else {
        this.onFailure();
    }
};